import React, {
  ReactElement,
  useState,
  Fragment,
} from 'react';
import { Button as MUIButton, List, Switch, TextField } from '@mui/material';
import Popover from '@mui/material/Popover';
import { debounce } from 'lodash';
import api from '../../services/api';

export const ColumnMenu = ({
  popupState,
  anchorEl,
  visibleColumns,
  sortedColumns,
  setPopupState,
  setVisibleColumns,
  schema,
  viewId,
  apiRef,
}: {
  popupState: any;
  anchorEl: any;
  visibleColumns: any;
  sortedColumns: any;
  setPopupState: (value: boolean) => void;
  setVisibleColumns: (value: any) => void;
  schema: any;
  viewId?: any;
  apiRef?: any;
}): ReactElement => {
  const [filterValue, setFilterValue] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState(visibleColumns);
  const [columnsForList, setColumnsForList] = useState<any>(
    Object.keys(columns).map((item: any) => {
      return { name: item };
    })
  );

  const debouncedOnChange = debounce(handleDebouncedOnChange, 300);

  function handleDebouncedOnChange(value: any) {
    setFilterValue(value);
  }

  const showColumns = (newColumn: any, show: any) => {
    setLoading(true);

    if (viewId) {
      let newCols: any = [...columnsForList];
      if (show) {
        newCols.push({ name: newColumn });
      } else {
        newCols = columnsForList.filter((column: any) => {
          return column?.name !== newColumn;
        });
      }

      setColumnsForList(newCols);

      setColumns({ ...columns, [`${newColumn}`]: show });
      setVisibleColumns({ ...columns, [`${newColumn}`]: show });

      const updatedView = api
        .patch(`/views/${viewId}`, {
          columns: newCols,
        })
        .then(() => {
          setLoading(false);
        });
    }
  };

  return (
    <>
      <Popover
        open={popupState}
        anchorEl={anchorEl?.current}
        onClose={() => {}}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div className={'p-[10px]'}>
          <div>
            <TextField
              autoFocus={true}
              id="standard-basic"
              label="Find Column"
              variant="standard"
              onChange={(event) => {
                debouncedOnChange(event?.target.value);
              }}
            />
          </div>

          <List
            sx={{
              width: '100%',
              maxWidth: 360,
              bgcolor: 'background.paper',
              paddingY: '10px',
              maxHeight: '300px',
              overflow: 'auto',
              pointerEvents: loading ? 'none' : 'auto',
              opacity: loading ? 0.8 : 1,
            }}
          >
            {Object.keys(schema.columns).map(
              (columnKey: any, index: number) => {
                const column = schema.columns[`${columnKey}`];
                if (
                  filterValue &&
                  !column?.name.toLowerCase().includes(filterValue)
                ) {
                  return <></>;
                }

                if (column?.hideInTableView) {
                  return <></>;
                }
                const name = column?.name ? column.name : column.headerName;
                const id = columnKey;

                return (
                  <div key={index} className={'flex flex-col'}>
                    <div
                      className={
                        'flex flex-row items-center justify-between cursor-grabbing'
                      }
                    >
                      <div
                        className={'flex flex-row items-center justify-start'}
                      >
                        <Switch
                          size="small"
                          defaultChecked={
                            visibleColumns[`${id}`] === undefined
                              ? false
                              : visibleColumns[`${id}`]
                          }
                          onChange={(event, checked) => {
                            showColumns(id, checked);
                          }}
                        />
                        <div>{name}</div>
                      </div>
                    </div>
                  </div>
                );
              }
            )}
          </List>

          <div>
            <MUIButton variant="outlined" onClick={() => setPopupState(false)}>
              Close
            </MUIButton>
          </div>
        </div>
      </Popover>
    </>
  );
};
